import { useIsOrgAdmin } from "./useIsOrgAdmin"

/**
 * Whether the current user may WRITE workspace settings — a global super-admin,
 * or the active organization's owner/admin. A plain member gets a read-only view.
 *
 * Mirrors the backend `PUT /settings` gate (`decideOrgSettingWrite`): model keys,
 * the tenant-operational whitelist, and the Teams integration config are all
 * owner/admin-only, so a member's save would 403. Panels use this to hide/disable
 * their save controls instead of letting a member click into an error.
 *
 * Thin alias over {@link useIsOrgAdmin} — the role test is identical; the two
 * names document *why* each surface is gated.
 */
export function useCanManageSettings(): boolean {
  return useIsOrgAdmin()
}
